import React from 'react'
import moment from 'moment'

// query
import { useQuery } from '@apollo/client'
import { GET_JOB_BY_ID_WITH_INFO } from '../../../../graphql/job/job.queries'

// components
import Card from '../../../../components/cards/Card/Card.component'
import CardDataPoint from '../../../../components/cards/CardDataPoint/CardDataPoint.component'

// icons
import { FontAwesomeIcon  } from '@fortawesome/react-fontawesome'
import { faInfo } from '@fortawesome/free-solid-svg-icons'


export default function JobInfo({ id }) {
    let job = {}
    const { loading, error, data } = useQuery(GET_JOB_BY_ID_WITH_INFO, {
        variables: { id }
    })

    if(data && data.job) {
        job = {...data.job}
    }

    return(<Card header={{ icon: <FontAwesomeIcon icon={faInfo} size='2x' color='#707070' />, title: 'Job'}}>
        <CardDataPoint label='Number' value={id} isLoading={loading} />
        <CardDataPoint label='Address' value={[`${job.street1 ? job.street1 : ""} ${job.street2 ? job.street2 : ""}`, `${job.city ? job.city : ""}${job.city && job.state ? "," : ""} ${job.state ? job.state : ""} ${job.zipcode ? job.zipcode : ""}`]} isLoading={loading} />
        <CardDataPoint label='Estimated Start Date' value={job.estimatedStartDate ? moment(job.estimatedStartDate).format("MM/DD/YY") : null} isLoading={loading} />
        <CardDataPoint label='Active' value={job.isActive ? 'Yes' : 'No'} isLoading={loading} />
    </Card>)
}